import React, { memo, useCallback, useMemo } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { LANGUAGES_SHORT, RESONANCE_VISIONS, SONAR_PROJECT_RANGE_TYPE } from '../../../constants';
import dayjs, { DATE_FORMATS } from '../../../utils/dateUtils';
import validate from '../../../utils/validate';
import CardWrapper, { EDIT_PROJECT_SECTION } from '../card-wrapper/CardWrapper';
import { editProjectNameFormYupValidation } from '../validation';
import NameFormInner from './NameFormInner';

const NameSection = ({ onSubmit }) => {
  const { t } = useTranslation('projects');
  const { id } = useParams();
  const { editProject = {} } = useSelector((state) => state.projects);
  const projectAgent = useSelector((state) => state.id8.projectAgent);

  const { month, year } = useMemo(() => {
    const startDate = editProject.startDate;

    const checkDate = dayjs(startDate, DATE_FORMATS.API_DATE);

    return {
      month: checkDate.format('MM'),
      year: checkDate.format('YYYY'),
    };
  }, [editProject.startDate]);

  const nameInitialValues = {
    projectName: editProject.projectName ?? '',

    theme: editProject.theme ?? '',
    vision: editProject.vision ?? RESONANCE_VISIONS.DEFAULT,
    lang: editProject.lang ?? LANGUAGES_SHORT.ENGLISH,
    dataStructure: editProject.dataStructure ?? '',

    startingFromMonth: month || '',
    startingFromYear: year || '',
    rangeType: editProject.rangeType || SONAR_PROJECT_RANGE_TYPE.DAILY_RANGE,

    brand: editProject.brand ?? '',

    description: editProject.description ?? '',
    referenceMessages: editProject.referenceMessages ?? '',
    thinking: editProject.thinking ?? false,

    agentId: projectAgent?.id ?? '',
    agentType: projectAgent?.type ?? '',
    agentReferenceId: '',
    instructions: projectAgent?.instructions ?? '',
  };

  const handleSubmitNameForm = useCallback(
    async (values) => {
      await onSubmit({ id, editProject: editProject, values: values });
    },
    [onSubmit, editProject, id],
  );

  return (
    <CardWrapper label={t('name')} sectionType={EDIT_PROJECT_SECTION.NAME}>
      <Form
        initialValues={nameInitialValues}
        onSubmit={handleSubmitNameForm}
        subscription={{ submitting: true, pristine: true }}
        validate={(values) => validate(values, editProjectNameFormYupValidation(editProject.projectType))}
        render={({ handleSubmit }) => (
          <NameFormInner
            onSubmit={handleSubmit}
            projectType={editProject.projectType}
            initialValues={nameInitialValues}
          />
        )}
      />
    </CardWrapper>
  );
};

export default memo(NameSection);
